<template>
  <v-breadcrumbs :items="items" class="pb-4 pl-0" v-if="items && items.length" data-testid="app-breadcrumbs">
    <template #item="{ item }">
      <span v-if="item.disabled" data-testid="app-breadcrumbs__item-disabled">{{ item.text }}</span>
      <router-link v-else :to="item.to" data-testid="app-breadcrumbs__item-link">{{ item.text }}</router-link>
    </template>
  </v-breadcrumbs>
</template>

<script>
export default {
  name: 'AppBreadcrumbs',
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}
</script>
